import { Caption, StatusChipPropsType } from "@/lib/main";
import { CSSProperties } from "react";

export default function StatusChip({
  children,
  addBorder,
  size,
  status,
}: StatusChipPropsType) {
  const styles: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",

    backgroundColor: `var(--color-background-${status}-tint)`,
    border: addBorder
      ? `var(--border-width-xs) solid var(--color-border-${status})`
      : "none",
    borderRadius: "var(--border-radius-md)",

    padding: "0rem var(--spacing-lg)",
    height: size === "md" ? "2rem" : "1.5rem",
    width: "fit-content",
    minWidth: "fit-content",
  };

  return (
    <Caption color={status} fontWeight={500} style={styles}>
      {children}
    </Caption>
  );
}
